import AddCounterparty from '@/components/add-counterparty/add-counterparty';

export default AddCounterparty;
